import { createContext } from 'react';

// Provides an optional "exit" affordance for the post-conversation survey.
// When a value is present, QuestionWrapper renders an Exit control in the top
// bar. It is intentionally null by default so unrelated questionnaires (e.g.
// signup flows) that reuse QuestionWrapper never show an exit button.
const SurveyExitContext = createContext(null);

export default SurveyExitContext;
